import { useState } from "react";
import { useDeleteApplicationMutation } from "../../apis/adminApiSlice";
import { capturePartnerEvent } from "../../utils/analytics";

export default function DeleteApplicationModal({ application, onClose, onDeleted }) {
  const [error, setError] = useState("");
  const [deleteApplication, { isLoading: deleting }] =
    useDeleteApplicationMutation();

  if (!application) return null;

  const displayEmail = (application.email || "").trim();

  const handleDelete = async () => {
    setError("");
    try {
      await deleteApplication({
        id: application.id,
      }).unwrap();
      capturePartnerEvent("partner_admin_application_deleted", {
        application_id: application.id,
        email: displayEmail,
      });
      onDeleted?.();
    } catch (e) {
      setError(e?.data?.error || e?.data?.detail || "Delete failed.");
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
      <div className="bg-mnf-dark-2 border border-white/10 rounded-mnf-lg p-6 max-w-md w-full">
        <h3 className="font-poppins font-semibold text-mnf-text-primary mb-2">
          Delete this application?
        </h3>
        <p className="text-sm text-mnf-text-muted mb-4">
          Do you really want to delete{" "}
          <span className="text-mnf-text-primary font-medium">{displayEmail}</span>?
        </p>
        {error && (
          <p className="text-xs text-mnf-error mb-3">{error}</p>
        )}
        <div className="flex gap-2 justify-end mt-4">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-xs text-mnf-text-secondary hover:text-mnf-text-primary"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleDelete}
            disabled={deleting}
            className="px-4 py-2 text-xs font-poppins font-semibold rounded-mnf bg-mnf-error text-white hover:brightness-110 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:brightness-100"
          >
            {deleting ? "Deleting..." : "Delete permanently"}
          </button>
        </div>
      </div>
    </div>
  );
}
